var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-inbox" } },
    [
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm.message
        ? _c(
            "v-alert",
            {
              staticStyle: {
                "margin-top": "50px",
                "margin-left": "50%",
                left: "-10%",
              },
              attrs: { type: "error", width: "20%" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-2 mt-3" },
                [
                  _c("v-text-field", {
                    staticStyle: { "margin-bottom": "-30px" },
                    attrs: {
                      label: "Key Name",
                      placeholder: "Enter value to find",
                      outlined: "",
                      clearable: "",
                      "append-icon": "mdi-magnify",
                    },
                    on: {
                      "click:append": _vm.searchAcount,
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchAcount.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.searchKey,
                      callback: function ($$v) {
                        _vm.searchKey = $$v
                      },
                      expression: "searchKey",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0 ml-2" },
                [
                  _c(
                    "v-tabs",
                    {
                      staticClass: "no-transition",
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _vm._l(_vm.tabs, function (item) {
                        return [
                          _c(
                            "v-tab",
                            {
                              key: "tab-l-keys-list-view-" + item.name,
                              on: { click: _vm.onPressTab },
                            },
                            [
                              _vm._v(_vm._s(item.name) + " "),
                              _c("country-flag", {
                                staticClass: "pl-0",
                                attrs: {
                                  country: item.flag,
                                  size: "normal",
                                  rounded: true,
                                },
                              }),
                              _vm.hasEmptyValues(item.name)
                                ? _c("v-badge", {
                                    attrs: {
                                      color: "red",
                                      bordered: "",
                                      icon: "mdi-exclamation-thick",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { outlined: "", width: "100%" },
                    },
                    [
                      _c(
                        "v-card-actions",
                        { staticClass: "ma-0 pa-2" },
                        [
                          _c(
                            "v-tabs-items",
                            {
                              staticClass: "mt-0",
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.tab,
                                callback: function ($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab",
                              },
                            },
                            [
                              _vm._l(_vm.tabs, function (item) {
                                return [
                                  _c(
                                    "v-tab-item",
                                    {
                                      key: "tab-l-keys-list-view-" + item.name,
                                      attrs: {
                                        transition: "fade-transition",
                                        "reverse-transition": "fade-transition",
                                      },
                                    },
                                    [
                                      _c("l-keys-list-view", {
                                        ref: "l-keys-list-view",
                                        refInFor: true,
                                        attrs: { language: item },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }